export default __webpack_public_path__ + "static/media/success-animation.8d3b250e.gif";